import styled, { css } from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

const desktopStyles = css`
  padding: 1rem 4.813rem;
  border-radius: 0.75rem;
  min-height: 15.625rem;
  justify-content: center;
`;

export const StyledCard = styled.div<{
  $image?: string;
  $isMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2.5rem 1rem 2rem;
  min-height: 15.625rem;
  gap: 1rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: ${COLORS.LIGHTEST_GRAY};
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  ${({ $isMobile }) => !$isMobile && desktopStyles};
  ${(props) => !!props.$image && `background-image: url(${props.$image});`};

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 0;
`;

export const StyledMobileWrapper = styled.div`
  max-width: 24rem;
`;

export const StyledTitle = styled.p<{ $isMobile?: boolean }>`
  ${({ $isMobile }) => pickThemeFontStyles($isMobile ? '28' : '36', $isMobile ? '28' : '36', 'BOLD')};
  color: ${COLORS.BLACK};
  ${({ $isMobile }) => !$isMobile && `max-width: 60%`};
  padding: 0;
  margin: 0;
`;

export const StyledSubTitle = styled.p<{ $isMobile?: boolean }>`
  ${({ $isMobile }) => pickThemeFontStyles($isMobile ? '16' : '20', $isMobile ? '24' : '30', 'NORMAL')};
  color: ${COLORS.BLACK};
  ${({ $isMobile }) => !$isMobile && `max-width: 60%`};
  padding: 0;
  margin: 0;
`;
